import React from "react";
import styles from "./index.module.css";

export class InvoiceFileInput extends React.Component {
  state = {
    file: null
  };

  render() {
    const { alreadyDidUpload } = this.props;
    const { file } = this.state;

    return (
      <div className={styles.container}>
        <label>
          <input
            disabled={this.props.disabled}
            tabIndex={-1}
            onChange={e => {
              const file = e.target.files[0];
              this.setState({ file }, () => this.props?.onChange(file));
            }}
            type="file"
          />
          <div className={styles["file-status-container"]}>
            <div className={styles.label}>Nota Fiscal anexada:</div>
            {file || alreadyDidUpload ? (
              <span className={styles.yes}>Sim</span>
            ) : (
              <span className={styles.no}>Não</span>
            )}
            {!alreadyDidUpload && !file && (
              <span className={styles.yes}>Anexar nota fiscal</span>
            )}
          </div>
        </label>
      </div>
    );
  }
}
